// SELECT CIDADE ESTADO
function selectStateCity(state, city, stateVal, cityVal) {
    if (stateVal == undefined && cityVal == undefined) {
        new dgCidadesEstados({
            cidade: document.getElementById(city),
            estado: document.getElementById(state)
        });
    } else {
        new dgCidadesEstados({
            cidade: document.getElementById(city),
            estado: document.getElementById(state),
            estadoVal: stateVal,
            cidadeVal:  cityVal
        });
    }
}